export const CHECKOUT_MESSAGES = [
  {
    code: [2010],
    icon: "RideFiErrorCardLight",
    title: "No tienes saldo suficiente",
    message:
      "La tarjeta con la que intentaste realizar el pago no cuenta con saldo suficiente. Intenta con otro medio de pago.",
    buttonText: "Entendido",
  },
  {
    code: [2005],
    icon: "RideFiErrorCardLight",
    title: "No se pudo procesar tu pago",
    message:
      "Comprueba que tu tarjeta y pagos en línea estén activos e inténtalo nuevamente.",
    buttonText: "Entendido",
  },
  {
    code: [2006],
    icon: "RideFiErrorCardLight",
    title: "Tarjeta inválida",
    message: "Para realizar el pago, ingresa otra tarjeta.",
    buttonText: "Entendido",
  },
  {
    code: [2033, 2002, 2015],
    icon: "RideFiErrorCardLight",
    title: "Ingresa nuevamente los datos de  tu tarjeta",
    message:
      "Uno de los datos que ingresaste no es correcto. Verifica y vuelve a intentar.",
    buttonText: "Entendido",
  },
];

export const DEFAULT_MESSAGE = {
  code: [],
  icon: "RideFiErrorCardLight",
  title: "Ocurrió un error",
  message:
    "¡Lo sentimos! No pudimos continuar con el proceso que realizabas. Inténtalo nuevamente.",
  buttonText: "Entendido",
};

export const FAILED_PAYMENT = {
  icon: "RideFiErrorCardLight",
  title: "No pudimos procesar tu pago",
  message:
    "Recuerda activar las compras por internet de tu tarjeta y, si usas CVV dinámico, revisa en la app de tu banco. Luego de verificar, intenta pagar nuevamente.",
  buttonText: "Volver a cotizar",
};

export const INACTIVE_MESSAGE = {
  icon: "RideFiInactivityLight",
  title: "Tu sesión ha expirado",
  message:
    "Estuviste inactivo por unos minutos. Por seguridad tu sesión expiró. Por favor, vuelve a iniciar sesión.",
  buttonText: "Entendido",
};
